import PropTypes from 'prop-types'
import { Images } from '@/theme/Images'
import CardDetailsDialog from './card-details-dialog'
import { useRef } from 'react'

const CreditCardContainer = () => {
  const viewCardDetailsFnRef = useRef(null)
  return (
    <div data-testid="left-column" className="flex flex-col w-full pb-6 md:border-b-dGray-200 md:border-b-[1px]">
      <div className="flex flex-col items-center">
        <div className="relative">
          <img src={Images.creditCardMockupNew} className="max-md:max-w-[330px] max-sm:max-w-[240px]" />
          <button
            data-testid="card-detail-dialog-trigger"
            onClick={() => viewCardDetailsFnRef.current?.openViewCardInfoWithSession()}
            className="absolute bottom-3 left-3 text-white text-sm font-semibold"
          >
            View Card Details
          </button>
        </div>
        <CardDetailsDialog viewCardDetailsFnRef={viewCardDetailsFnRef} />
      </div>
    </div>
  )
}
CreditCardContainer.propTypes = {
  data: PropTypes.object,
}

export default CreditCardContainer
